import { Routes, Route } from "react-router-dom";
import CourseLandingPage from "../modules/courses/CourseLandingPage";
import HomePage from "../modules/HomePage";

const PublicRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/course/:id" element={<CourseLandingPage />} />
      </Routes>
    </>
  );
};

export default PublicRoutes;
